import { forwardRef } from "react";
import { inr, fmtDay, PAY_LABEL } from "./shared";
import { IMAGES, CONTACT } from "../../data/products";

export const Invoice = forwardRef(({ o }, ref) => (
    <div ref={ref} className="invoice bg-white text-black p-10 max-w-3xl mx-auto" data-testid="invoice">
        <div className="flex justify-between items-start border-b border-black/20 pb-6 mb-8">
            <div className="flex items-center gap-4">
                <img src={IMAGES.logo} alt="Al Zahra" className="w-14 mix-blend-multiply" />
                <div>
                    <p className="font-serif text-2xl tracking-wide">AL ZAHRA PERFUMERY</p>
                    <p className="text-xs text-black/60">2/A Zakaria Street, Kolkata 700073 · {CONTACT.whatsappDisplay} · {CONTACT.website}</p>
                </div>
            </div>
            <div className="text-right">
                <p className="text-[10px] tracking-[0.3em] uppercase text-black/50">Tax Invoice</p>
                <p className="font-serif text-xl">#{o.ref}</p>
                <p className="text-xs text-black/60">{fmtDay(o.created_at)}</p>
            </div>
        </div>
        <div className="grid grid-cols-2 gap-8 mb-8 text-sm">
            <div>
                <p className="text-[10px] tracking-[0.25em] uppercase text-black/50 mb-2">Bill to / Ship to</p>
                <p className="font-medium">{o.name}</p>
                <p>{o.phone}</p>
                <p className="text-black/70 leading-relaxed">{o.address}{o.pincode ? `, ${o.city || ""} ${o.state || ""} – ${o.pincode}` : ""}</p>
            </div>
            <div className="text-right">
                <p className="text-[10px] tracking-[0.25em] uppercase text-black/50 mb-2">Payment</p>
                <p className="capitalize">{o.payment_method} · {PAY_LABEL[o.payment_status] ?? o.payment_status}</p>
                {o.payment_id && <p className="text-xs text-black/60 break-all">{o.payment_id}</p>}
                {o.shipment?.awb_code && <p className="text-xs text-black/60 mt-2">{o.shipment.courier} · AWB {o.shipment.awb_code}</p>}
            </div>
        </div>
        <table className="w-full text-sm mb-6">
            <thead><tr className="border-b border-black/30 text-[10px] tracking-[0.2em] uppercase text-black/50"><th className="text-left py-2 font-normal">Item</th><th className="text-right py-2 font-normal">Qty</th><th className="text-right py-2 font-normal">Rate</th><th className="text-right py-2 font-normal">Amount</th></tr></thead>
            <tbody className="divide-y divide-black/10">
                {o.items.map((it, i) => <tr key={i}><td className="py-2">{it.name}</td><td className="py-2 text-right">{it.qty}</td><td className="py-2 text-right">{inr(it.price)}</td><td className="py-2 text-right">{inr(it.price * it.qty)}</td></tr>)}
            </tbody>
        </table>
        <div className="ml-auto w-64 text-sm space-y-1">
            <div className="flex justify-between"><span className="text-black/60">Subtotal</span><span>{inr(o.subtotal ?? o.total - (o.shipping_fee || 0))}</span></div>
            <div className="flex justify-between"><span className="text-black/60">Delivery{o.shipping_courier ? ` (${o.shipping_courier})` : ""}</span><span>{inr(o.shipping_fee || 0)}</span></div>
            <div className="flex justify-between border-t border-black/30 pt-2 font-serif text-lg"><span>Total</span><span>{inr(o.total)}</span></div>
            <p className="text-[10px] text-black/50 pt-1">Prices inclusive of all taxes.</p>
        </div>
        <p className="text-center text-xs text-black/50 mt-12">Thank you for choosing Al Zahra — your invisible crown.</p>
    </div>
));
